import React, { useState } from "react";
import {
  Box,
  Typography,
  MenuItem,
  TextField,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";
import { CreatePublicAction, PublicAction, PublicLinkActionType } from "../../interfaces/DTO/PublicAction";
import { publicActionService } from "../../services/PublicActionService";
import { buildPublicTokenUrl, formatPublicLinkActionType } from "../../utils/featuresFormatter";


interface GeneratePublicLinkProps {
  contactId: number;
}

export const GeneratePublicLink: React.FC<GeneratePublicLinkProps> = ({ contactId }) => {
  const [purpose, setPurpose] = useState<PublicLinkActionType>(PublicLinkActionType.UPDATE_CONTACT);
  const [link, setLink] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const dto = CreatePublicAction.defaultEmpty();
      dto.contact_id = contactId;
      dto.action_type = purpose;
      // Do not send string "null". Either omit or send null.
      dto.meta_data = null;
      const response: PublicAction = await publicActionService.createToken(dto);
      const fullUrl = buildPublicTokenUrl(response.secret);
      setLink(fullUrl);
      setError(null);
    } catch (err: any) {
      setError(err?.response?.data?.detail || "שגיאה ביצירת קישור ציבורי");
      setLink(null);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    if (link) {
      navigator.clipboard.writeText(link);
      setCopied(true);
    }
  };

  return (
    <Box mt={4} p={2} borderRadius={2} boxShadow={1} bgcolor="background.paper">
      <Typography variant="h6" gutterBottom>
        יצירת קישור ציבורי ללקוח
      </Typography>
      <TextField
        select
        fullWidth
        label="בחר סוג קישור"
        value={purpose}
        onChange={(e) => setPurpose(e.target.value as PublicLinkActionType)}
        margin="normal"
      >
        {Object.values(PublicLinkActionType).map((p) => (
          <MenuItem key={p} value={p}>
            {formatPublicLinkActionType(p)}
          </MenuItem>
        ))}
      </TextField>

      <Button variant="contained" onClick={handleGenerate} disabled={loading} fullWidth sx={{ mt: 2 }}>
        צור קישור
      </Button>

      {link && (
        <Box mt={2}>
          <Alert severity="success">
            <Typography variant="body2" sx={{ wordBreak: "break-word" }}>{link}</Typography>
            <Button onClick={handleCopy} size="small" sx={{ mt: 1 }}>
              העתק קישור
            </Button>
          </Alert>
        </Box>
      )}

      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        message="הקישור הועתק"
      />
    </Box>
  );
};

export default GeneratePublicLink;
